import { generatePath, matchPath } from 'react-router'

// endDate 는 포함하지 않는다. 9/30 하루 전체를 담으려면 다음날 자정이 상한이 된다.
const 내신준비기간 = {
  startDate: new Date('2026-09-02T00:00:00'),
  endDate: new Date('2026-10-01T00:00:00'),
}

export const getIsSchoolExamZonePeriod = () => {
  const now = new Date()
  return now >= 내신준비기간.startDate && now < 내신준비기간.endDate
}

export const getEntrancePage = (
  { isSchoolflat, isSeoltab }: { isSchoolflat: boolean; isSeoltab: boolean },
  shouldNavigateToUpdatedContents?: boolean,
) => {
  if (isSchoolflat) {
    return RouteName.dashboard
  }

  if (isSeoltab) {
    return RouteName.textbookWorksheet
  }

  if (getIsSchoolExamZonePeriod()) {
    return RouteName.schoolExamZone
  }

  if (shouldNavigateToUpdatedContents) {
    return RouteName.updatedContents
  }

  return RouteName.worksheet
}

export const RouteName = {
  button: '/button-test',
  root: '/',
  login: '/login',
  mobileHome: '/mobile', // 휴대폰 로그인 직후 고르기 (QR 채점 / 데스크탑 버전). 휴대폰 전용 화면은 모두 이 아래에 둔다
  mobileLogin: '/mobile/login', // 휴대폰 로그인. 휴대폰에서 /login 을 열면 이리로 온다
  mobileQr: '/mobile/qr', // 휴대폰 QR 채점 진입. 휴대폰에서 /qr 을 열면 이리로 온다
  mobileStudentSelect: '/mobile/worksheets/:worksheetId', // 휴대폰 QR 채점 — 학습지를 출제받은 학생 고르기
  mobileGroupScoring: '/mobile/worksheets/:worksheetId/students/:studentWorksheetId', // 휴대폰 QR 채점 — 학생 목록에서 고른 학생 채점
  mobileStudentScoring: '/mobile/qr/worksheets/:worksheetId/students/:studentWorksheetId', // 휴대폰 QR 채점 — 학생별 QR 로 바로 연 채점

  lessonDailyLearning: '/lesson/daily-learning', // 오늘의 학습
  lessonDailyLearningLiveLesson:
    '/lesson/daily-learning/live-lesson/:studentWorksheetId/:studentId', // 오늘의 학습 - 모니터링 (전체뷰)
  lessonDailyLearningLiveLessonStudent:
    '/lesson/daily-learning/student/:studentId/:studentWorksheetId', // 오늘의 학습 - 모니터링 (개인뷰)

  schoolExamZone: '/lesson-preparation/school-exam', // 내신관 (= 내신 대비 섹션 베이스)
  updatedContents: '/updated-contents', // 콘텐츠 업데이트
  updatedContentsById: '/updated-contents/:contentId', // 콘텐츠 업데이트

  busanLogin: '/pen',
  jeonnamLogin: '/whalespace',
  aiOnOAuthLogin: '/whale/connect', // 광주 아이온 - 네이버 웍스 SSO 로그인 요청 경로
  aiOnOAuthCallback: '/whale/callback', // 광주 아이온 - 네이버 웍스 SSO 로그인 이후 떨어지는 콜백 경로 (redirect_uri)
  aiepBridge: '/aiep/bridge', // AIEP 로그인 이후 떨어지는 콜백 경로 (redirect_uri)
  weizmannBridge: '/weizmann/bridge', // Weizmann 로그인 이후 떨어지는 콜백 경로 (redirect_uri)
  publicLogin: '/school-login',
  guestLogin: '/f4c8a9e7b5d1a6f3', // 외부 시연용 계정 세팅, magic 로그인 경로
  seoltabLogin: '/seoltab', // 설탭, magic 로그인 경로
  scienceflatConnect: '/connect/scienceflat', // 사이언스플랫 연동 동의 페이지
  onlineOnboardingBridge: '/online-onboarding/bridge', // 매쓰플랫 온라인 온보딩(큐브메이커) SSO 토큰 발행 후 외부 리다이렉트
  creverseLogin: '/creverse/login', // 크레버스 직원 SSO 진입 페이지
  creverseBridge: '/creverse/bridge', // 크레버스 SSO 로그인 이후 떨어지는 콜백 경로 (ssoToken 수신)
  vineLogin: '/vine/login', // 바인그룹 직원 SSO 진입 페이지
  vineBridge: '/vine/bridge', // 바인그룹 SSO 로그인 이후 떨어지는 콜백 경로 (ssoToken 수신)

  passwordReset: '/password-reset',
  passwordResetValid: '/password-reset/valid/:token',
  passwordResetExpired: '/password-reset/expired',
  passwordResetCompleted: '/password-reset/completed',
  phoneAuth: '/phone-auth/:status',

  initSetting: '/init', // 초기 셋팅 화면
  registerLogo: '/init/logo', // 초기 셋팅 1단계
  confirmAcademyLogo: '/init/confirm-academy-logo', // 학원 로고 등록 완료 화면
  extraInfo: '/init/extra-info', // 초기 셋팅 2단계
  scenarioGuide: '/init/scenario-guide', // 초기 셋팅 3단계

  academyInfoUpdate: '/academy-info-update', // 학원정보 업데이트 화면

  // 홈
  main: '/main',
  home: '/home',
  dashboard: '/home/dashboard',

  // 수업준비
  lessonPreparation: '/lesson-preparation', // 수업준비
  worksheet: '/lesson-preparation/worksheet', // 수업준비 - 학습지
  academyShareScopeWorksheet: '/lesson-preparation/worksheet/by-academy', // 센터 학습지
  myDB: '/lesson-preparation/worksheet/my-db', // 나의 DB
  myDBEdit: '/my-db-edit', // 나의 DB 문제 편집
  favoriteWorksheet: '/lesson-preparation/worksheet/favorite-worksheet', // 즐겨찾기
  worksheetTrash: '/lesson-preparation/worksheet/trash', // 학습지 휴지통

  // academy-group 전용 학습지 탭
  academyGroupShareScopeWorksheet: '/lesson-preparation/worksheet/by-academy-group', // 센터 공유 학습지

  /** @deprecated `RouteName.academyShareScopeWorksheet` 를 사용하세요 */
  _myWorksheet: '/lesson-preparation/worksheet/my-worksheet',

  workbook: '/lesson-preparation/workbook', // 교재
  signatureWorkbook: '/lesson-preparation/workbook/signature-workbook', // 시그니처 교재
  academyGroupWorkbook: '/lesson-preparation/workbook/academy-group-workbook', // 학원그룹교재
  publicWorkbook: '/lesson-preparation/workbook/public-workbook', // 시중교재

  // 커스텀 교재 share-scope 탭
  academyShareScopeWorkbook: '/lesson-preparation/workbook/by-academy', // 센터 교재 (기본)
  academyGroupShareScopeWorkbook: '/lesson-preparation/workbook/by-academy-group', // 센터 공유 교재

  // 자동시험 (cas 의 한 변종)
  cas: '/lesson-preparation/cas',

  // 입학고사 (크레버스 비재원생 입학고사)
  entranceTest: '/lesson-preparation/entrance-test',
  entranceTestWorksheet: '/lesson-preparation/entrance-test/worksheet',
  entranceTestAcademyShareScopeWorksheet: '/lesson-preparation/entrance-test/worksheet/by-academy',
  entranceTestAcademyGroupShareScopeWorksheet:
    '/lesson-preparation/entrance-test/worksheet/by-academy-group',
  entranceTestWorksheetTrash: '/lesson-preparation/entrance-test/worksheet/trash',
  entranceTestCas: '/lesson-preparation/entrance-test/cas',

  /** @deprecated `RouteName.academyShareScopeWorkbook` 를 사용하세요 */
  _myWorkbook: '/lesson-preparation/workbook/my-workbook',

  schoolTest: '/lesson-preparation/school-test', // 학교별 기출

  // LNB 리뉴얼: 옛 '테마별 추천학습지'(theme-worksheet) 묶음이 '시험 대비'(exam 하위)와
  // '영역별 학습'(강의처럼 lesson-preparation 직속 평탄 경로)으로 재편됨.
  // theme-worksheet 경로엔 더 이상 페이지가 없다 (legacyTheme 포함 모두 하위호환 리다이렉트).
  // 영역별 학습 (lesson-preparation 직속)
  arithmetic: '/lesson-preparation/arithmetic', // 연산
  essayWorksheet: '/lesson-preparation/essay-worksheet', // 내신 대비 서술형
  lecture: '/lesson-preparation/lecture', // 강의

  // 시험 대비 — LNB 메뉴(내신대비/수능·모의고사/테스트)별로 2depth 를 나눈다.
  // 그래야 "마지막 본 탭 복원"이 메뉴 단위로 동작하고(getLastLocation 은 /header/subHeader 로 기억),
  // LNB active 매칭도 배열 없이 해당 2depth prefix 하나로 잡힌다.
  // 내신 대비 (school-exam)
  recommend: '/lesson-preparation/school-exam/recommend', // 추천학습지
  textbookWorksheet: '/lesson-preparation/school-exam/textbook-worksheet', // 교과서 (쌍둥이)학습지
  // 수능·모의고사 (csat)
  practiceTest: '/lesson-preparation/csat/practice-test', // 모의고사
  practiceTestPair: '/lesson-preparation/csat/practice-test-pair', // 모의고사 쌍둥이
  satWorksheet: '/lesson-preparation/csat/sat-worksheet', // 수능특강/수능완성
  kmmExamWorksheet: '/lesson-preparation/csat/kmm-exam', // KMM수학경시대회
  policeMilitaryPracticeTest: '/lesson-preparation/csat/police-military-practice-test', // 경찰대/사관학교
  policeMilitaryPracticeTestPair: '/lesson-preparation/csat/police-military-practice-test-pair', // 경찰대/사관학교 쌍둥이
  // 테스트 (test)
  themeEntranceTest: '/lesson-preparation/test/entrance-test', // 입학 테스트
  weeklyTest: '/lesson-preparation/test/weekly-test', // 주간 테스트
  chapterTest: '/lesson-preparation/test/chapter-test', // 단원 테스트
  generalTest: '/lesson-preparation/test/general-test', // 총괄 테스트

  // 시험 대비 섹션별 2depth 베이스 (LNB 메뉴 to 의 getLastLocation 인자 & active 매칭용)
  schoolExamRoot: '/lesson-preparation/school-exam',
  csatRoot: '/lesson-preparation/csat',
  testRoot: '/lesson-preparation/test',

  // LNB 리뉴얼 구 경로 하위호환 (legacyRouteRedirects 에서 신규 경로로 리다이렉트)
  legacyArithmetic: '/lesson-preparation/theme-worksheet/arithmetic',
  legacyEssayWorksheet: '/lesson-preparation/theme-worksheet/essay-worksheet',
  legacyRecommend: '/lesson-preparation/theme-worksheet/recommend',
  legacyTextbookWorksheet: '/lesson-preparation/theme-worksheet/textbook-worksheet',
  legacyPracticeTest: '/lesson-preparation/theme-worksheet/practice-test',
  legacyPracticeTestPair: '/lesson-preparation/theme-worksheet/practice-test-pair',
  legacyThemeEntranceTest: '/lesson-preparation/theme-worksheet/entrance-test',
  legacyWeeklyTest: '/lesson-preparation/theme-worksheet/weekly-test',
  legacyChapterTest: '/lesson-preparation/theme-worksheet/chapter-test',
  legacyGeneralTest: '/lesson-preparation/theme-worksheet/general-test',
  legacySatWorksheet: '/lesson-preparation/theme-worksheet/sat-worksheet',
  legacyPoliceMilitaryPracticeTest:
    '/lesson-preparation/theme-worksheet/police-military-practice-test',
  legacyPoliceMilitaryPracticeTestPair:
    '/lesson-preparation/theme-worksheet/police-military-practice-test-pair',
  legacySchoolExamZone: '/school-exam-zone',
  legacyKmmExamWorksheet: '/lesson-preparation/theme-worksheet/kmm-exam',
  legacyTheme: '/lesson-preparation/theme-worksheet',

  // KMM수학경시대회
  kmmRoot: '/lesson-preparation/kmm-exam',
  kmmOverview: '/lesson-preparation/kmm-exam/overview',
  kmmGuideline: '/lesson-preparation/kmm-exam/guideline',
  kmmRegister: '/lesson-preparation/kmm-exam/register',
  kmmHighSchoolRegister: '/lesson-preparation/kmm-exam/high-school-register',
  kmmApplyMaterials: '/lesson-preparation/kmm-exam/apply-materials',

  // 와이즈만 전국 수학학력평가
  weizmannExam: '/lesson-preparation/weizmann-exam',

  share: '/lesson-preparation/share-worksheet', // 다른 기관 학습지

  // 시그니처 교재 만들기
  makeSignatureWorkbook: '/make-signature-workbook', // 시그니처 교재 선택 (풀모달)
  makeSignatureWorkbookProductList: '/make-signature-workbook/product-list', // 시그니처 교재 선택 (풀모달)
  makeSignatureWorkbookCover: '/make-signature-workbook/cover', // 시그니처 교재 편집 (풀모달)
  makeSignatureWorkbookCoverCreate: '/make-signature-workbook/cover/create/:workbookId', // 시그니처 교재 편집 - 생성 (풀모달)
  makeSignatureWorkbookCoverEditOrCopyEdit:
    '/make-signature-workbook/cover/:copyOption/:workbookId', // 시그니처 교재 편집 - 수정 혹은 복제 후 수정 (풀모달)

  // 학습지 만들기
  makeWorksheet: '/make-worksheet',
  makeWorksheetBy: '/make-worksheet/by',
  makeWorksheetByChapter: '/make-worksheet/by/chapter', // 단원 유형별
  makeWorksheetByWorkbook: '/make-worksheet/by/workbook', // 시중교재
  makeWorksheetByWorkbookDetail: '/make-worksheet/by/workbook/:workbookId', // 시중교재 선택
  makeWorksheetByPracticeTest: '/make-worksheet/by/practice-test', // 수능 모의고사
  makeWorksheetBySignatureWorkbook: '/make-worksheet/by/signature-workbook', // 시그니처 교재
  makeWorksheetBySignatureWorkbookDetail: '/make-worksheet/by/signature-workbook/:workbookId', // 시그니처 교재 선택
  makeWorksheetBySchoolTest: '/make-worksheet/by/school-test', // 학교 내신 기출
  makeWorksheetByPaper: '/make-worksheet/by/scanner', // 기출 업로드
  makeWorksheetByArithmetic: '/make-worksheet/by/arithmetic', // 연산
  makeCas: '/make-cas', // 자동시험 만들기 (단독 풀스크린)
  worksheetFileUpload: '/worksheet-file-upload', // 학습지 파일 업로드
  worksheetFileUploadUploader: '/worksheet-file-upload/uploader',
  worksheetFileUploadList: '/worksheet-file-upload/list',
  worksheetFileUploadEdit: '/worksheet-file-upload/edit',
  editWorksheetProblems: '/make-worksheet/edit/:filterId', // 2단계
  workSheetOptions: '/make-worksheet/options/:filterId', // 3단계

  // 교재 만들기
  makeCustomWorkbook: '/make-workbook',
  /**
   * @deprecated
   */
  _makeCustomWorkbookStep1: '/make-workbook/by',
  /**
   * @deprecated
   */
  _makeCustomWorkbookStep1ByWorkbook: '/make-workbook/by/workbook', // 시중교재
  /**
   * @deprecated
   */
  _makeCustomWorkbookStep1ByWorkbookDetail: '/make-workbook/by/workbook/:workbookId', // 시중교재 선택

  makeCustomWorkbookStepOne: '/make-workbook/step1',
  makeCustomWorkbookStepOneConcept: '/make-workbook/step1/concept', // 단원 유형별
  makeCustomWorkbookStepOneWorkbookProblem: '/make-workbook/step1/workbook', // 시중교재
  makeCustomWorkbookStepOneWorkbookProblemDetail: '/make-workbook/step1/workbook/:workbookId', // 시중교재 선택
  makeCustomWorkbookStepOneSchoolTest: '/make-workbook/step1/school-test', // 학교별기출
  makeCustomWorkbookStepTwo: '/make-workbook/step2', // 2단계
  makeCustomWorkbookStepTwoCreate: '/make-workbook/step2/create', // 2단계
  makeCustomWorkbookStepTwoEdit: '/make-workbook/step2/:buildMode/:workbookId', // 2단계 수정, 복제후수정
  makeCustomWorkbookStepThree: '/make-workbook/step3', // 3단계
  makeCustomWorkbookStepThreeCreate: '/make-workbook/step3/create', // 3단계
  makeCustomWorkbookStepThreeEdit: '/make-workbook/step3/:buildMode/:workbookId', // 3단계 수정, 복제후수정

  // --------

  // 기관
  academy: '/academy', // 기관 기본
  academyManage: '/academy/manage', // 운영 관리
  studentManage: '/academy/manage/student', // 학생 관리
  classManage: '/academy/manage/class', // 반 관리
  createClass: '/create-class', // 반 생성
  modifyClass: '/modify-class/:classId', // 반 수정
  teacherManage: '/academy/manage/teacher', // 선생님 관리
  academyAuthManage: '/academy/manage/auth', // 권한설정
  academyOptionsManage: '/academy/manage/options', // 기관설정
  parentAppAnnouncementManage: '/academy/manage/parents-app', // 학부모앱 공지
  studentAppManage: '/academy/manage/student-app', // 학생앱 설정
  legacy__StudentAnswerManage: '/academy/manage/show-answer', // (구)정답 공개 관리
  studentAnswerManage: '/academy/manage/student-app/show-answer', // 정답 공개 관리
  studentProblemVideoManage: '/academy/manage/student-app/show-problem-video', // 풀이 영상 공개 관리
  studentTodayLearningManage: '/academy/manage/student-app/today-learning', // 오늘의 학습 설정
  laboratoryManage: '/academy/manage/laboratory', // 실험실
  aiTutorManage: '/academy/manage/laboratory/ai-tutor', // AI 튜터
  oneClickWorksheetManage: '/academy/manage/laboratory/one-click-worksheet', // 원클릭 복습 학습지
  achievementAnalysisReportManage: '/academy/manage/laboratory/achievement-analysis-report', // 성취도 분석 보고서
  kmmAutoAssigningManage: '/academy/manage/laboratory/kmm-auto-assigning', // KMM 자동출제 관리
  shareWorksheetSetting: '/academy/manage/laboratory/worksheet-shared-setting', // 다른 기관 학습지
  essayAiScoringManage: '/academy/manage/laboratory/essay-ai-scoring', // 서술형 AI 채점

  smsManage: '/academy/sms', // 문자관리
  smsSend: '/academy/sms/send', //문자 전송
  smsHistory: '/academy/sms/history', //문자 내역

  attendance: '/academy/attendance', // 출결관리 - 기본
  attendanceManage: '/academy/attendance/manage', // 출결관리

  attendanceManageGrade: '/academy/attendance/manage/grade/:gradeKey/:type',
  attendanceManageClass: '/academy/attendance/manage/lesson-class/:lessonClassId/:type',
  attendanceManageStudent: '/academy/attendance/manage/student/:studentId/:type',
  AcademyTuitionManage: '/academy/attendance/tuition', // 교육비 관리

  customer: '/mypage/customer', // 고객지원
  customerSupportedWorkbook: '/mypage/customer/supported-workbook', // 시중교재 지원 정보
  customerSupportedWorkbookList: '/mypage/customer/supported-workbook/list', // 시중교재 22개정 지원 목록
  customerSupportedWorkbookPlan: '/mypage/customer/supported-workbook/plan', // 시중교재 22개정 지원 계획

  customerNotice: '/mypage/customer/notice', // 공지 및 업데이트
  customerFaq: '/mypage/customer/faq', // 자주묻는 질문
  customerQna: '/mypage/customer/qna', // 1:1질문
  supportWorkbook: '/support-workbook-list', // 시중교재 지원 정보(public 경로라 list라는 nested 경로 생겼음에도 경로 수정 못함)
  supportWorkbookList: '/support-workbook-list/list', // 시중교재 22개정 지원 목록
  supportWorkbookListPlan: '/support-workbook-list/plan', // 시중교재 22개정 지원 계획

  vodColumn: '/mypage/vod-column', // VOD·칼럼 탭 (헤더)
  vodColumnList: '/mypage/vod-column/list', // VOD·칼럼 목록 (sub헤더)
  vodColumnDetail: '/mypage/vod-column/list/:id', // VOD·칼럼 상세 (sub헤더)
  review: '/mypage/vod-column/review', // 후기

  // --------

  // 수업
  lesson: '/lesson',

  // 수업 - 학습내역
  lessonLearningHistory: '/lesson/learning-history',
  lessonLearningHistoryStudent: '/lesson/learning-history/student/:studentId',
  lessonLearningHistoryGrade: '/lesson/learning-history/grade/:gradeKey',
  lessonLearningHistoryClass: '/lesson/learning-history/lesson-class/:lessonClassId',

  // 수업 - 유형분석
  achievementAnalysis: '/lesson/achievement-analysis',
  achievementAnalysisByStudent: '/lesson/achievement-analysis/student/:studentId',
  achievementAnalysisByGrade: '/lesson/achievement-analysis/grade/:gradeKey',
  achievementAnalysisClass: '/lesson/achievement-analysis/lesson-class/:lessonClassId',

  // 수업 - 학습지
  lessonWorksheet: '/lesson/worksheet',
  lessonWorksheetStudent: '/lesson/worksheet/student/:studentId',
  lessonWorksheetGrade: '/lesson/worksheet/grade/:gradeKey',
  lessonWorksheetClass: '/lesson/worksheet/lesson-class/:lessonClassId',

  // 수업 - 교재
  lessonWorkbook: '/lesson/workbook',
  lessonWorkbookStudent: '/lesson/workbook/student/:studentId',
  lessonWorkbookGrade: '/lesson/workbook/grade/:gradeKey',
  lessonWorkbookClass: '/lesson/workbook/lesson-class/:lessonClassId',

  // 수업 - 자동시험 (반응형평가 자동시험)
  lessonCas: '/lesson/auto-test',
  lessonCasStudent: '/lesson/auto-test/student/:studentId',
  lessonCasGrade: '/lesson/auto-test/grade/:gradeKey',
  lessonCasClass: '/lesson/auto-test/lesson-class/:lessonClassId',

  // 수업 - 비재원생(guest) 입학고사. 학생 단위 진입(학년별 라우트 없음).
  lessonGuestEntranceTest: '/lesson/guest/entrance-test',
  lessonGuestEntranceTestWorksheet: '/lesson/guest/entrance-test/worksheet',
  lessonGuestEntranceTestWorksheetStudent:
    '/lesson/guest/entrance-test/worksheet/student/:studentId',
  lessonGuestEntranceTestCas: '/lesson/guest/entrance-test/cas',
  lessonGuestEntranceTestCasStudent: '/lesson/guest/entrance-test/cas/student/:studentId',

  // 수업 - 보고서
  lessonReport: '/lesson/report',
  lessonReportStudent: '/lesson/report/student/:studentId',
  lessonReportGrade: '/lesson/report/grade/:gradeKey',
  lessonReportClass: '/lesson/report/lesson-class/:lessonClassId',

  // V1 보고서 (구버전 - MONTHLY, 단일 페이지)
  createLessonReport: '/create-report/:groupType/:key',
  updateLessonReport: '/update-report/:groupType/:key/:reportId',

  // V2 보고서 (신버전 - CUSTOM_PERIOD, 2단계)
  createLessonReportStepOne: '/create-report/:groupType/:key/step1',
  createLessonReportStepTwo: '/create-report/:groupType/:key/step2',
  // updateLessonReportStepOne: '/update-report/:groupType/:key/:reportId/step1', // 이런 경로는 없습니다.
  updateLessonReportStepTwo: '/update-report/:groupType/:key/:reportId/step2',
  // 실시간 보고서에서 커스텀 보고서 생성
  createLessonReportFromRealTime: '/create-report-from-realtime/:groupType/:key',

  // 모니터링
  liveLessonBoard: '/lesson/live-lesson-board/:groupStudentWorksheetId',
  liveLessonPerson: '/lesson/live-lesson-person/:groupStudentWorksheetId/:studentId',

  // n차 학습지
  lessonWorksheetDerivation: '/student-derivation/:derivationType/:studentId', // 2차 학습지만들기 (단원, 기간별)
  derivationByChapter: '/student-derivation/by-chapter/:studentId',
  derivationByDate: '/student-derivation/by-date/:studentId',
  derivationByWorksheet: '/student-derivation/by-worksheet/:studentId',

  // 학습지 그룹 채점
  lessonWorksheetGroupScoring: '/group-scoring/:groupStudentWorksheetId',

  // 학력평가 시험지 그룹 채점
  examGroupScoring: '/exam-scoring/:examId',

  // 자동시험 그룹 채점 - 반(lesson-class) 기준
  casGroupScoringByLessonClass: '/cas-scoring/lesson-class/:lessonClassId/:casId',
  // 자동시험 그룹 채점 - 학년(grade) 기준
  casGroupScoringByGrade: '/cas-scoring/grade/:schoolType/:grade/:casId',

  noLessonWorkbook: '/lesson/no-workbook',

  // POD Mall
  podMall: '/pod-mall',
  // podMallBookList: '/pod-mall/books',
  podMallBook: '/pod-mall/book/:productId',
  podMallCart: '/pod-mall/cart',
  podMallEdit: '/pod-mall/edit/:productId',
  podMallCopyAndEdit: '/pod-mall/copy-edit/:productId',
  podMallOrder: '/pod-mall/order/:preOrderId',
  podMallOrderSuccess: '/pod-mall/order-success',
  podMallOrderFailure: '/pod-mall/order-failure',
  podMallManage: '/pod-mall/manage',
  podMallPurchase: '/pod-mall/manage/purchase-list',
  podMallUser: '/pod-mall/manage/user',
  podMallCoupon: '/pod-mall/manage/coupon',

  // class: '/class',
  // studentRegister: '/class/studentRegister',
  // groupManager: '/class/groupManager',
  // sms: '/sms',
  // auth: '/auth',

  // attendance: '/attendance',
  // teacher: '/teacher',
  // guide: '/guide',
  // guideDesktop: '/guide-Desktop',
  // publicBook: '/publicbook',

  // sheets: '/sheets',
  // custombook: '/custombook',
  // recommend: '/recommend',
  // mocktest: '/mocktest',

  // share: '/share',
  // makebook: '/makebook',
  // makepiece: '/makepiece',
  // makeMocktest: '/make-mocktest',
  // makePublicbook: '/make-publicbook',
  // editProblems: '/editProblems', // 교재만들기, 학습지만들기 2단계
  // printOptions: '/printOptions', // 교재만들기, 학습지만들기 3단계

  // history: '/lesson/history',
  // textbook: '/lesson/textbook',
  // textpaper: '/lesson/textpaper',
  // report: '/lesson/report',

  myInfo: '/mypage', // 내정보
  myUserInfo: '/mypage/user-info', // 내정보
  myStatus: '/mypage/user-usage', // 이용 현황
  mySettlement: '/mypage/settlement/workbook', // 교재비 정산
  guide: '/mypage/guide', // 사용가이드

  additionalUsage: '/additional-usage', //추가 요금 내역 풀모달
  smsUsage: '/sms-usage', //문자 요금 내역 풀모달
  hwpDownloadHistory: '/hwp-download-history', // hwp 학습지 다운로드 내역 풀모달
  serverMaintenance: '/server-maintenance', // 서버 점검 화면
  // myinfoUpdate: '/myinfo-update',
  // myinfoPassword: '/myinfo-password',
  // noticeBrowserGuide: '/notice-browser-guide',
  // contract: '/contract-initial',
  // password: '/password',
  // notice: '/notice'

  // 웹뷰 관련
  webview: '/webview',
  // 수업 - 기타
  designTemplate: '/webview/design-template',
  // 수업하기 (시그니처 교재 수업하기)
  signatureWorkbookViewer: `/signature-workbook-viewer/:workbookId/teacher/:pageNumber`,
  signatureWorkbookViewerByStudent: `/signature-workbook-viewer/:workbookId/:studentWorkbookRevisionId/:pageNumber`,
  // 수업하기 (학원그룹교재 수업하기)
  academyGroupWorkbookViewer: `/academy-group-workbook-viewer/:workbookId/teacher/:pageNumber`,
  academyGroupWorkbookViewerByStudent: `/academy-group-workbook-viewer/:workbookId/:studentWorkbookRevisionId/:pageNumber`,
  // 학부모 결제
  parentPayment: '/parent-payment',
  parentPaymentSuccess: '/parent-payment/success',
  parentPaymentFailure: '/parent-payment/failure',

  // 커스텀프린팅
  customPrint: '/custom-print',

  // QR 채점 진입. 학생 웹·Android 앱과 맞춘 외부 계약 주소라 바꾸지 않는다
  qrScoring: '/qr',

  // Tally 폼 임베드 (개인정보 URL 노출 방지용 래퍼)
  tallyEmbed: '/tally-embed',

  // 개발용 테스트 페이지
  devPaperEditTest: '/dev/paper-edit-test',
} as const

/**
 * LNB '시험 대비'(school-exam·csat·test)·'영역별 학습'(연산·서술형) 섹션에 속한 학습지 라우트 집합.
 * (내 학습지가 아닌, 제공형 학습지 — 내신관 schoolExamZone 은 LessonMaterial 이 아니라 제외)
 * 경로 prefix 가 여러 갈래라 substring 이 아니라 prefix 멤버십으로 판별한다.
 */
export const EXAM_AND_CATEGORY_WORKSHEET_ROUTES: string[] = [
  RouteName.textbookWorksheet,
  RouteName.recommend,
  RouteName.essayWorksheet,
  RouteName.practiceTest,
  RouteName.practiceTestPair,
  RouteName.themeEntranceTest,
  RouteName.weeklyTest,
  RouteName.chapterTest,
  RouteName.generalTest,
  RouteName.satWorksheet,
  RouteName.kmmExamWorksheet,
  RouteName.policeMilitaryPracticeTest,
  RouteName.policeMilitaryPracticeTestPair,
  RouteName.arithmetic,
]

// 위 라우트들의 옛 위치(/theme-worksheet/*)는 App 라우트로 진입하면 리다이렉트되지만,
// EditWorksheet 의 entryPath 처럼 쿼리 값으로 넘어오는 옛 경로는 리다이렉트를 거치지 않으므로
// legacyTheme prefix 도 같은 집합으로 본다.
const EXAM_AND_CATEGORY_WORKSHEET_ROUTE_PREFIXES: string[] = [
  ...EXAM_AND_CATEGORY_WORKSHEET_ROUTES,
  RouteName.legacyTheme,
]

export const isExamOrCategoryWorksheetRoute = (pathname: string) => {
  const pathOnly = pathname.split(/[?#]/)[0]

  return EXAM_AND_CATEGORY_WORKSHEET_ROUTE_PREFIXES.some(
    (route) => pathOnly === route || pathOnly.startsWith(`${route}/`),
  )
}

export const fullModalRoutes: Array<string> = [
  RouteName.makeWorksheet,
  RouteName.makeCas,
  RouteName.makeCustomWorkbook,
  RouteName.worksheetFileUpload,
  RouteName.createClass,
  RouteName.additionalUsage,
  RouteName.smsUsage,
  RouteName.hwpDownloadHistory,
  RouteName.supportWorkbook,
  RouteName.modifyClass,
  RouteName.createLessonReportStepOne,
  RouteName.createLessonReportStepTwo,
  RouteName.updateLessonReportStepTwo,
  RouteName.initSetting,
  RouteName.registerLogo,
  RouteName.confirmAcademyLogo,
  RouteName.extraInfo,
  RouteName.scenarioGuide,
  RouteName.derivationByChapter,
  RouteName.derivationByDate,
  RouteName.derivationByWorksheet,
  RouteName.podMall,
  RouteName.myDBEdit,
  RouteName.qrScoring,
]

export const PUBLIC_ROUTES = [
  RouteName.passwordReset,
  RouteName.phoneAuth,
  RouteName.supportWorkbook,
  RouteName.parentPayment,
  RouteName.parentPaymentSuccess,
  RouteName.parentPaymentFailure,
]

export const isPublicRoute = (pathname: string) =>
  PUBLIC_ROUTES.some((route) => matchPath(pathname, { path: route }))

/**
 * @description 로그인 페이지로 리다이렉트 하지 않아야 하는 경로
 */
export const NOT_ALLOWED_TO_REDIRECT_TO_LOGIN_PATH = [RouteName.root, RouteName.workSheetOptions]

export const SCREEN_SIZE_GUIDE_EXCLUDE_ROUTES = [
  RouteName.phoneAuth,
  RouteName.parentPayment,
  RouteName.parentPaymentSuccess,
  RouteName.parentPaymentFailure,
]

export const AUTH_ROUTES = [
  RouteName.login,
  RouteName.mobileLogin,
  RouteName.busanLogin,
  RouteName.jeonnamLogin,
  RouteName.publicLogin,
  RouteName.aiOnOAuthLogin,
  RouteName.aiOnOAuthCallback,
  RouteName.aiepBridge,
  RouteName.weizmannBridge,
  RouteName.guestLogin,
  RouteName.seoltabLogin,
  RouteName.scienceflatConnect,
  RouteName.creverseLogin,
  RouteName.creverseBridge,
  RouteName.vineLogin,
  RouteName.vineBridge,
]

export type AuthRoute = (typeof AUTH_ROUTES)[number]

// bridge/callback(SSO 토큰 교환 경유지)·magic 자동 로그인·연동 동의 페이지는 제외 — 진입 페이지로 튕기면 플로우가 깨진다
export const LOGIN_ENTRY_ROUTES: AuthRoute[] = [
  RouteName.login,
  RouteName.mobileLogin,
  RouteName.busanLogin,
  RouteName.jeonnamLogin,
  RouteName.publicLogin,
  RouteName.creverseLogin,
  RouteName.vineLogin,
]

export const 시중교재전체지원_콘텐츠업데이트_경로 = generatePath(RouteName.updatedContentsById, {
  contentId: '5',
})

export const 수능_콘텐츠_업데이트_경로 = RouteName.essayWorksheet
